import { Injectable } from '@angular/core'; 
import { AngularFireAuth } from "@angular/fire/auth";
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, take } from 'rxjs/operators';

@Injectable({ 
    providedIn: 'root' 
  }) 
  export class ResetPasswordService {
    userData: Observable<firebase.User>;

    constructor(private angularFireAuth: AngularFireAuth) { 
        this.userData = angularFireAuth.authState;
    } 
    /** 
     * Initiate the password reset process for this user 
     * @param email email of the user 
     */ 
    resetPasswordInit(email: string) {
      return this.angularFireAuth.sendPasswordResetEmail(email)
        .then(() => {
          window.alert('Password reset email sent, check your inbox.');
        }).catch((error) => {
          window.alert(error)
        })
      }
  }